// Whether a form-field element can currently receive focus. readOnly inputs are
// still focusable (PrimeReact Dropdown's focus target is a readOnly role=combobox
// input); only `disabled` blocks focus. offsetParent is null for elements removed
// from layout (display:none, hidden tab).
export const isFormFieldFocusable = (el: HTMLElement): boolean => {
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
    if (el.disabled) {
      return false;
    }
  }
  return el.offsetParent !== null;
};
